export const cards = {
    cardDisplay: {
        displayLessonBreadcrumb: {usages: true, concepts: true, chapters: true, skills: false},
        showButtonBookmarks: {
            lesson: true,
            model: true,
            community: true,
            image: true,
            video: true,
            videoUrl: true,
            audio: true,
            document: true,
            url: true,
        },
        isTextButton: true,
    },
    cardFields: {
        default: {
            lesson: ['title', 'titleIcon', 'menu', 'image', 'description', 'keywords-chip-list', 'button-assign-as-label-in-action-menu', 'skills', 'difficulty', 'author', 'share-lesson'],
            model: ['title', 'titleIcon', 'menu', 'image', 'description', 'keywords-chip-list', 'button-assign-as-label-in-action-menu', 'skills', 'difficulty', 'author', 'share-lesson'],
            community: ['title', 'titleIcon', 'menu', 'description', 'image', 'usage', 'skills', 'difficulty', 'target-age', 'author', 'share-lesson'],
            image: ['title', 'titleIcon', 'menu', 'image', 'skills', 'difficulty'],
            video: ['title', 'titleIcon', 'menu', 'image', 'skills', 'difficulty'],
            videoUrl: ['title', 'titleIcon', 'menu', 'image', 'skills', 'difficulty'],
            audio: ['title', 'titleIcon', 'menu', 'image', 'skills', 'difficulty'],
            document: ['title', 'titleIcon', 'menu', 'image', 'skills', 'difficulty'],
            url: ['title', 'titleIcon', 'menu', 'image', 'skills', 'difficulty'],
        }
    },
    cardDefaultHeader: '/assets/verdinum/images/backgrounds/img_default_lesson.svg',
    cardPlayOpenMenu: false,
    chooseSubLessonFeatureActive: {
        default: false,
        trainer: true,
    },
    isLaunchLessonAskModalActive: {default: true},
    isLaunchLessonAskTitle: true,
    menuLinks: {
        lesson: {
            default: ['add', 'edit', 'editOwn', 'delete', 'deleteOwn', 'assign', 'duplicate'],
            trainer: ['add', 'editOwn', 'delete', 'deleteOwn', 'assign', 'duplicate']
        },
        model: {
            administrator: ['add', 'edit', 'editOwn', 'delete', 'deleteOwn', 'duplicate'],
            manager: ['duplicate'],
            default: []
        }
    },
    multiPdfDownload: false,
    hidePlayPreviewFromFavoritesPage: true,
    allowedMultiPdfDownloadFromFavoritePage: true,
    viewLessonPage: true, //allow to show lesson page
    moveActionsButtonInMenu: {
        default: {
            lesson: true,
            default: false
        }
    }// Display all button in menu button except bookmark and open lesson page
};
